export default __webpack_public_path__ + "static/media/SEN-POW-PRE.ad065fcf.png";